export default __webpack_public_path__ + "static/media/Thief's Bracers of the Tenth Court.2d16eef1.jpg";